import { render, staticRenderFns } from "./certSourceDetails.vue?vue&type=template&id=4bb10b7e&scoped=true"
import script from "./certSourceDetails.vue?vue&type=script&lang=js"
export * from "./certSourceDetails.vue?vue&type=script&lang=js"
import style0 from "./certSourceDetails.vue?vue&type=style&index=0&id=4bb10b7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb10b7e",
  null
  
)

export default component.exports